<template>
  <div :class="{'HotelTeam':type==3}">
    <div class="order-team" v-if="type==2">
        <!--1.订单旅行社信息-->
            <div class="travel">
                <div class="travel-title">{{orderDetail.status==5&&orderDetail.send_type==3?'等待采购商确认':'采购商信息'}}</div>
                <div>
                    <div class="travel-desc" v-if="orderDetail.send_mobile">
                        <img :src="orderDetail.send_avatar?$GFUN.formatImgSrc(orderDetail.send_avatar,66,66):'/images/avatar/avatar_0.png'">
                        <div class="travel-name">
                            <p>
                                <el-tooltip effect="dark" content="认证旅行社" placement="top" >
                                    <img src="/images/public/is_travel.png" alt="" class="is_travel" v-if="orderDetail.is_travel==1">
                                </el-tooltip>
                                {{orderDetail.travel_title||'个人用户'}}
                            </p>
                            <p>
                                <i class="icon-kehu iconfont"></i><span>{{orderDetail.send_name}}</span>
                                <el-tooltip effect="dark" :content="orderDetail.send_is_real==0?'未实名':'已实名认证'" placement="top" >
                                    <i class="icon-cedaohang-kehuguanli iconfont " :class="{ 'text-success':orderDetail.send_is_real==1}"></i>
                                </el-tooltip>
                            </p>
                            <!--成交时再显示手机号-->
                            <p v-if="orderDetail.deal_time>0||$GFUN.isInArray([2,99],storeInfo.type)"><i class="icon-dianhua iconfont"></i> <span>{{orderDetail.send_mobile}}</span></p>
                        </div>
                    </div>
                    <div class="qRCode mt-4" v-if="orderDetail.status==5&&orderDetail.send_type==3">
                        <el-button :loading="loading" @click="modifyOrder" type="success" class="bottom" size="small" icon="el-icon-full-screen">查看确认二维码</el-button>
                        <p class="qrcode-desc">可分享二维码扫描查看确认</p>
                    </div>
                    <!--发票标识-->
                    <div class="invoice" :class="{'invoice-active':orderDetail.send_receipt}"  @click="showInvoice(2,orderDetail.send_receipt)" v-if="$GFUN.isInArray([6,7,8,9],orderDetail.status)&&!flag">
                        <span class="invoice-text">发票</span>
                    </div>
                </div>
            </div>
            <!--用房信息-->
            <div class="housing">
                <div class="housing-title">用房信息</div>
                <ul class="housing-list">
                    <li><p>订单类型:</p><div>{{orderDetail.order_type==1?'住宿订单':'纯会议订单'}}</div></li>
                    <li><p>团  号:</p><div>{{orderDetail.title}}</div></li>
                    <li v-if="orderDetail.order_type==1"><p>入住人数:</p><div>{{orderDetail.num}}人</div></li>
                    <li v-if="orderDetail.order_type==1&&orderDetail.deal_time==0"><p>早餐类型:</p><div>{{orderDetail.breakfast}}</div></li>
                    <li v-if="orderDetail.eatery"><p>正餐类型:</p><div><span class="mr-1"  v-for="item in starns(orderDetail.eatery,'eateryArr')" :key="item">{{item}}</span></div></li> 
                    <!-- <li v-if="orderDetail.room_need_arr.num>0"><p>用房总数:</p><div>{{orderDetail.room_need_arr.num}}间</div></li>  -->
                    <li v-if="orderDetail.order_type==1"><p>入离日期:</p><div>{{orderDetail.date_in | formatTimestamp(2)}} ~ {{orderDetail.date_out | formatTimestamp(2)}} (共{{orderDetail.days}}晚)</div></li>
                    <li v-if="orderDetail.other"><p>会议设施:</p><div><span class="mr-1"  v-for="item in starns(orderDetail.other,'meetRoomObj')" :key="item">{{item}}</span></div></li> 
                    <li v-if="storeInfo.type!=3"><p>星级需求:</p><div><span class="mr-1"  v-for="item in starns(orderDetail.star,'HotelStar')" :key="item">{{item}}</span></div></li> 
                    <li v-if="storeInfo.type!=3"><p>用房区域:</p><div>{{orderDetail.province_name}}省&ensp;{{orderDetail.city_name}}市&ensp;{{orderDetail.district_name}}</div></li> 
                </ul>
            </div>
    </div>
    <!--2.成交酒店信息-->
    <template v-if="type==3">
        <div class="travelHotel min-height">
            <div class="travel-title">酒店信息</div>
            <div>
                <div class="travel-desc">
                    <img v-lazy="$GFUN.formatImgSrc(orderDetail.hotel_top_pic,64,64)" class="hotel-img cursor-pointer"/>
                    <div class="travel-name">
                        <p class="title">
                            {{orderDetail.hotel_title}}
                            <img class="ml-1" v-lazy="'/images/zfxj/icon_'+orderDetail.hotel_state_star+'.png'" :key="orderDetail.hotel_state_star" height="18px" v-if="orderDetail.hotel_state_star>0"/>
                            <img class="ml-1" v-lazy="'/images/xj/icon_'+orderDetail.hotel_star+'.png'" :key="orderDetail.hotel_star" height="18px" v-else/>
                        </p>
                        <template>
                            <p>
                                <i class="icon-kehu iconfont"></i> <span>{{orderDetail.offer_name||orderDetail.offer_name}}</span>
                                <el-tooltip effect="dark" :content="orderDetail.offer_is_real==0?'未实名':'已实名认证'" placement="top" >
                                    <i class="icon-cedaohang-kehuguanli iconfont " :class="{ 'text-success':orderDetail.offer_is_real==1}"></i>
                                </el-tooltip>
                            </p>
                            <p><i class="icon-dianhua iconfont"></i> <span>{{orderDetail.offer_mobile}}</span></p>
                        </template>
                    </div>
                </div>
            </div>
            <template v-if="orderDetail.deal_time>0">
                <div class="frontDeskPhone">前台电话：{{orderDetail.hotel_tel}}</div>
                <div class="frontDeskPhone none">报价说明：{{orderDetail.offer_remark||'无'}}</div>
            </template>
            <!--发布-->
            <div class="qRCode" v-if="orderDetail.status==5&&orderDetail.send_type==2&&storeInfo.type!=3">
                <el-button :loading="loading" @click="modifyOrder" type="success" class="bottom" size="small" icon="el-icon-full-screen">查看确认二维码</el-button>
                <p class="qrcode-desc">可分享二维码扫描查看确认</p>
            </div>
            <div class="qRCode border-top pt-3" v-else-if="orderDetail.status==5&&orderDetail.send_type==2">
                <p class="qrcode-desc">等待酒店销售确认中~</p>
            </div>
            <!--发票标识-->
            <div class="invoice" :class="{'invoice-active':orderDetail.offer_receipt}"  @click="showInvoice(3,orderDetail.offer_receipt)" v-if="$GFUN.isInArray([6,7,8,9],orderDetail.status)&&!flag">
                <span class="invoice-text">发票</span>
            </div>
        </div>
        <!--入住名单信息-->
        <OrderCheckList :orderDetail="orderDetail" @getorderDetail="getorderDetail" v-if="!flag"></OrderCheckList>
    </template>
    <!--确认二维码-->
    <el-dialog  :visible.sync="payQrcodeShow" width="360px"  :show-close="false" center  :z-index="11" top="32vh" >
        <div class="onDehalf-title">
            <div>确认二维码</div>
            <img :src="payQrcodeImg" width="200px" height="200px" class="base64Img">
            <p class="hotel-title">可扫码查看或分享确认</p>
            <el-button  @click="payQrcodeShow=false" class="bottom mt-3" size="small">返回</el-button>
        </div>
    </el-dialog>
  </div>
</template>

<script>
import OrderCheckList from './OrderCheckList' //核房人、支付人、入住名单
import { mapGetters,mapActions} from 'vuex'
export default {
  name: '',
  components: {
    OrderCheckList
  },
  props: {
    orderDetail: {
      type: Object,
      default: () => {}
    },
    type: {
      type: Number,
      default: 2
    },
    flag: {
      type: String,
      default: ''
    }
    ,
  },
  data() {
    return {
        payQrcodeImg:'',
        payQrcodeShow:false,
        loading:false,
        paymentDetail:{}
    };
  },
  computed: {
    ...mapGetters(['storeInfo','isAdmin']),
  },
  watch: {},
  created() {},
  mounted() {},
  methods: {
    ...mapActions(['POST_GetOrderDetailQRCode']),
    //星级需求
    starns(e,type){
        let result
        if(!e)return['无']
        if(!e.toString().includes(',')){
          result=new Array(e)
        }else{
          if(!Array.isArray(e)){
            result=e.split(',')
          }
        }
        let n=this.$options.filters['formatStars'](result,type);
        return n
    },
    //获取订单详情
    getorderDetail(){
      this.$emit('getorderDetail');
    },
    //获取确认二维码
    modifyOrder(){
        let _this=this;
        //已获取过不重新调用
        if(this.payQrcodeImg){
            this.payQrcodeShow=true;
            return;
        }
        //获取确认二维码
        this.loading=true;
        this.POST_GetOrderDetailQRCode({
            data:{
                oid: this.orderDetail.oid
            },
            flag:'cc',
            successFun: (res) => {
                _this.payQrcodeImg='data:image/jpeg;base64,'+res.qr_code;
                _this.payQrcodeShow=true;
                _this.loading=false;
            }
        })
    },
    //显示发票
    showInvoice(e,receipt){
        let oneself=this.storeInfo.type==e;
        
        if(!receipt&&!oneself&&!this.isAdmin){
            this.$message({
                message: '未上传发票信息',
                type: 'warning'
            });
            return;
        }else{
            console.log(oneself)
            this.$emit('uploadInvoice',{editMode:oneself,receipt:receipt,type:e});
        }
    },
  }
};
</script>

<style lang="scss" scoped>
    .order-team{
        display: flex;
        justify-content: space-between;
        margin-top: 20px;
    }
    .travel{
        width: 25%;
        padding: 16px 1%;
        background-color: #fff;
        border-radius: 6px;
        position: relative;
        overflow: hidden;
    }
    .HotelTeam{
        width: 27%;
    }
    .travelHotel{
        width: 92%;
        padding: 16px 4%;
        background-color: #fff;
        border-radius: 6px;
        position: relative;
        overflow: hidden;
    }
    .min-height{
        height: max-content;
        min-height: 190px;
    }
    .travel-title,.housing-title{
        font-weight: bold;
        font-size: 16px;
    }
    .travel-desc{
        margin-top: 16px;
        display: flex;
        >img{
            width: 80px;
        }
        .travel-name{
            margin-left: 16px;
            height: 80px;
            display: flex;
            justify-content: center;
            flex-direction: column;
            p{
                margin-top: 6px;
                display: flex;
                align-items: center;
                i{
                    font-size: 14px;
                    margin-right: 6px;
                    color: #666;
                }
            }
            p:nth-child(1){
                font-size: 16px;
                font-weight: bold;
                margin-top:0;
            }
        }
    }
    .housing{
        width: 70%;
        padding: 16px 1%;
        background-color: #fff;
        border-radius: 6px;
    }
    .housing-list{
        display: flex;
        flex-wrap: wrap;
        li{
            width: 49%;
            margin-top: 12px;
            p{
                width: 80px;
                color: #999;
                float: left;
            }
            div{
                display: inline-block;
                width: 78%;
            }
        }
    }
    .title{
        font-weight: bold;  
        font-size: 16px;
        display: inline-flex;
        align-items: center; /* 图片垂直居中 */
    }
    .frontDeskPhone{
        margin-top: 8px;
        border-top: 1px #eee solid;
        padding-top: 8px;
        font-size: 12px;
        color: #666;
    }
    .none{
        border-top: none;
        margin-top: 4px;
        padding-top: 4px;
    }
    .qRCode{
        display: flex;
        justify-content: center;
        flex-direction: column;
        margin-top: 16px;
    }
    .qrcode-desc{
        text-align: center;
        color:#999;
        font-size: 12px;
        margin-top: 8px;
    }
    .onDehalf-title{
        font-size: 18px;
        font-weight: bold;
        color: #333;
        text-align: center;
        position: relative;
    }
    .base64Img{
        margin-top: 20px;
    }
    .hotel-title{
        color: #999;
        font-size: 12px;
        font-weight: normal;
        margin-top: 8px;
    }
    .invoice{
        position: absolute;
        top: -25px;
        right: -25px;
        background-color: #cbcbcb;
        width: 50px;
        height: 50px;
        color: #fff;
        transform: rotate(45deg);
        font-size: 10px;
        cursor: pointer;
    }
    .invoice-text{
        margin-top: 33px;
        display: block;
        margin-left: 15px;
    }
    .invoice-active{
        background-color: var(--smtc-color-primary);
    }
    .icon-cedaohang-kehuguanli{
        margin-left: 6px;
        font-size: 18px !important;
        color: #999 !important;
        cursor: pointer;
        margin-top: 2px;
    }
    .text-success{
        color: var(--smtc-color-primary) !important;
    }
    .is_travel{
        width: 16px;
        height: 16px;
        display: inline-block;
        margin-top: 2px;
        margin-right: 4px !important;
        cursor: pointer;
    }
</style>
